import { TemplatePage } from './types';

const blogPromotionPage: TemplatePage = {
  header: {
    color: '#F7D06B',
    icon: 'images/video-templates/blog-promotion.jpg',
    title: 'Blog Promotion Video Templates',
    title_meta: '150+ Free and Editable Blog Promotion Video Templates',
    description_meta:
      'Promote your blog and get more eyes on your content with appealing videos. Explore 150+ customizable video ' +
      'templates that are cut out for blog promotion. ',
    description:
      'Draw attention to your blog promoting it with videos across all channels. Repurpose bits and pieces of your ' +
      'written content into video clips. These video templates will help you win new followers and retain existing ' +
      'subscribers.'
  },
  footer: {
    category: 'Blog Promotion',
    description:
      'Customizable video templates help you significantly speed up the video production process. It’s easy to ' +
      'adopt any template to your specific use case and message. All you need to do is replacing the sample ' +
      'footage and entering your texts. Unlimited branding possibilities allow you to create your unique video ' +
      'content and get it ready for sharing in minutes.'
  },
  content: [
    {
      type: 'templates',
      title: 'Blog Promotion Video Templates',
      search: { category: '/Use Cases/Blog Promotion' }
    },
    {
      type: 'stocks',
      title: 'blog promotion',
      search: { name: 'blog promotion' }
    },
    { type: 'calendar' }
  ]
};

export default blogPromotionPage;
